export enum TicketStatus {
  DRAFT = 'DRAFT',
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING = 'WAITING',
  RESOLVED = 'RESOLVED',
  ARCHIVED = 'ARCHIVED'
}
